// on scroll if window is on top of the page, add a class to body tag, else remove it
window.addEventListener('scroll', () => {
  if (window.scrollY > 30) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }
});

// also set the class on load
if (window.scrollY > 30) {
  document.body.classList.add('scrolled');
}

document.querySelectorAll('details.mega-menu').forEach((details) => {
  details.addEventListener('mouseover', function () {
    details.setAttribute('open', true);
  });

  details.addEventListener('mouseout', function () {
    details.removeAttribute('open');
  });
});

// when 1 of .header__inline-menu details is opened, close all others
document.querySelectorAll('.header__inline-menu details').forEach((details) => {
  details.addEventListener('toggle', function () {
    if (this.open) {
      // close all others
      document.querySelectorAll('.header__inline-menu details').forEach((otherDetails) => {
        if (otherDetails !== this) {
          otherDetails.removeAttribute('open');
        }
      })
    }
  });
})

// Go back
function goBack() {
  window.history.back(); 
}

// 
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});

// Card slider
$('.cardslide').owlCarousel({
  margin: 15, 
  loop: true,
  nav: true,
  autoplay: true,
  autoplayTimeout: 3000, 
  autoplayHoverPause: true,
  dots: false,
  smartSpeed: 800,
  responsive: {
      0: {
        items: 1.2
      },
      600: {
        items: 2.2 
      },
      768: {
        items: 2.2
      },
      1000: {
        items: 2.5
      },
      1280: {
        items: 2.5
      },
      1366: {
        items: 3.5
      },
      1536: {
        items: 3.5
      }
  }
})


// 

// Testimonial
$('.testimonial').owlCarousel({
  autoplay: false,
  loop: true,
  nav: true,
  dots: false,
  items: 1,
  autoHeight: true,
  smartSpeed: 800,
})


// tab collage
document.addEventListener('DOMContentLoaded', function() {
  // Select all tabs and tab content
  const tabs = document.querySelectorAll('#tabs-nav a');
  const tabContents = document.querySelectorAll('.tab-content');

  // Function to show content and highlight the active tab
  function showTabContent(event) {
    event.preventDefault();

    // Remove the 'active' class from all tabs and content
    tabs.forEach(tab => tab.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));

    // Add 'active' class to the clicked tab and its corresponding content
    const targetId = event.target.getAttribute('href').substring(1);
    const targetContent = document.getElementById(targetId);

    event.target.classList.add('active');
    targetContent.classList.add('active');
  }

  // Add event listener for each tab
  tabs.forEach(tab => {
    tab.addEventListener('click', showTabContent);
  });

  // Optionally, set the first tab as active by default
  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    tabContents[0].classList.add('active');
  }
});


// Athletes slider
$('.athletes').owlCarousel({
  margin: 15, 
  loop: true,
  nav: true,
  autoplay: true,
  smartSpeed: 800,
  touchDrag: true,
  mouseDrag: true,
  dots: false,
  responsive: {
      0: {
        items: 1.2
      },
      600: {
        items: 2
      },
      768: {
        items: 3
      },
      1000: {
        items: 4
      },
      1280: {
        items: 4
      },
      1366: {
        items: 5
      },
      1536: {
        items: 5
      }
  }
})


// // Define the colors to replace and the new color
// const colorsToReplace = ['#80ff00', '#1eff00', '#4cff00'];
// const newColor = '#82C341'; // Replace with your desired color

// // Loop through each color to replace
// colorsToReplace.forEach(color => {
//     // Select all span elements with the specific color
//     const spans = document.querySelectorAll(`span[style="color: ${color};"]`);

//     // Update the color for each matching span
//     spans.forEach(span => {
//         span.style.color = newColor;
//     });
// });



// Athletes product slider
$('.AthletesProduct').owlCarousel({
  margin: 15, 
  loop: true,
  nav: true,
  autoplay: true,
  center: false,
  dots: false,
  smartSpeed: 800,
  responsive: {
      0: {
        items: 1.5
      },
      600: {
        items: 2.5 
      },
      768: {
        items: 2.5
      },
      1000: {
        items: 3.5
      },
      1280: {
        items: 3.5
      },
      1366: {
        items: 4.5
      },
      1536: {
        items: 4.5
      }
  }
})


// Dual image slider
$('.dualimage').owlCarousel({
  loop: false,
  nav: true,
  dots: false,
  items: 1,
  smartSpeed: 1000,
})



// Athletes pdp slider
$('.AthletesPDProduct').owlCarousel({
  margin: 15, 
  loop: true,
  nav: true,
  autoplay: true,
  center: false,
  dots: false,
  smartSpeed: 800,
  responsive: {
      0: {
        items: 1.2
      },
      600: {
        items: 2.2 
      },
      768: {
        items: 2.2
      },
      1000: {
        items: 3.2
      },
      1280: {
        items: 3.2
      },
      1366: {
        items: 4.2
      },
      1536: {
        items: 5.2
      }
  }
})



// My slider
$('#MySlider').owlCarousel({
  margin: 15, 
  loop: false,
  nav: true,
  autoplay: true,
  autoplayTimeout: 3000, 
  autoplayHoverPause: true,
  dots: false,
  smartSpeed: 800,
  responsive: {
      0: {
        items: 2
      },
      600: {
        items: 3
      },
      768: {
        items: 4
      },
      1000: {
        items: 6
      }
  }
})

// counter
var a = 0;
$(window).scroll(function() {
  var $counter = $('#counter');

  if ($counter.length) {
    var oTop = $counter.offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
      $('.counter-value').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },
  
          {
  
            duration: 2000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
              //alert('finished');
            }
  
          });
      });
      a = 1;
    }
  }

});